export const environment = {
  apiUrl: 'https://elpefuture.gr',
  recapchaKey: "6LcDREIeAAAAAM9Yc1fUpIZ-hCmwVQ6AyPvrxx5l",
  domainCookieLang: '.elpefuture.gr',
  production: true,
  googleMapsApiKey: 'AIzaSyAK9FaZH2MRFLsn0BaG02eQ85Fze53yplk',
  enableBannerFeature: false,
};